/* unplugin-vue-components disabled */import { render } from "./CompanyIntroduction.vue?vue&type=template&id=0de34e98&scoped=true"
import script from "./CompanyIntroduction.vue?vue&type=script&lang=js"
export * from "./CompanyIntroduction.vue?vue&type=script&lang=js"

import "./CompanyIntroduction.vue?vue&type=style&index=0&id=0de34e98&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de34e98"]])

export default __exports__